import React, { FC, useMemo } from 'react'
import { Shared } from 'ui/shared'
import Grid from '@mui/material/Grid'
import { Form } from 'utils/helpers/form'
import { useTranslation } from 'react-i18next'
import { I18nModal } from 'utils/i18n/i18nModal'
import { shallowEqual, useDispatch, useSelector } from 'react-redux'
import { TState } from 'redux/config/root-types'
import { useForm } from 'react-hook-form'
import { Actions_CurrentUser } from 'redux/modules/currentUser/Actions'
import { Actions_Modals } from 'redux/modules/modals/Actions'
import { TStations } from 'redux/modules/stations/TReducer'

interface IForm {
  stationId: number
}

type TModalProps = {
  userId: number
  chargeOnlyInsurance?: boolean
  chargeUser: boolean
}

export const CompleteRent: FC = () => {
  const { t } = useTranslation(I18nModal.completeRent)
  const dispatch = useDispatch()

  const { isLoadingStations, isCompleteRentInProgress, stations, modalProps, userRent } = useSelector(
    ({ stations, currentUser, modals, rents }: TState) => ({
      isLoadingStations: stations.isLoading,
      isCompleteRentInProgress: currentUser.isLoading,
      stations: stations.data || [],
      modalProps: modals.data as TModalProps,
      userRent: rents.userRent,
    }),
    shallowEqual,
  )

  const { handleSubmit, errors, control } = useForm<IForm>()

  const onSubmit = (formData: IForm) => {
    const data = {
      userId: modalProps.userId,
      chargeUser: modalProps.chargeUser,
      chargeOnlyInsurance: modalProps.chargeOnlyInsurance,
      finishStationId: formData.stationId,
    }

    dispatch(Actions_CurrentUser.saga.completeRent(data))
  }

  const closeModal = () => {
    dispatch(Actions_Modals.store.hideModal())
  }

  const stationsOptions = stations
    .filter((item) => item.station.parkingId === userRent?.finishParking.id)
    .map(({ station }) => ({
      id: station.id,
      label: station.stationCode,
      value: station.id,
    }))

  return (
    <Shared.Card style={{ width: 375 }}>
      <form autoComplete="off" onSubmit={handleSubmit(onSubmit)}>
        <Grid container spacing={1}>
          <Grid item xs={12}>
            <Shared.CardTitle title={t('title')} />
          </Grid>

          <Grid item xs={12}>
            <Shared.AutocompleteForForm
              name="stationId"
              label={t('station')}
              options={stationsOptions}
              control={control}
              rules={Form.required}
              error={errors.stationId?.message}
            />
          </Grid>

          <Grid item xs={12}>
            <Shared.Button
              style={{ margin: '3.75em 0 0.875em 0' }}
              color={'secondary'}
              title={t('cancel')}
              onClick={closeModal}
              disabled={isCompleteRentInProgress}
            />
            <Shared.Button title={t('submit')} type={'submit'} disabled={isCompleteRentInProgress} />
          </Grid>

          {(isLoadingStations || isCompleteRentInProgress) && <Shared.Preloader mask />}
        </Grid>
      </form>
    </Shared.Card>
  )
}
